import { render, staticRenderFns } from "./OrderColumnType.vue?vue&type=template&id=2f61c894&"
import script from "./OrderColumnType.vue?vue&type=script&lang=ts&"
export * from "./OrderColumnType.vue?vue&type=script&lang=ts&"
import style0 from "./OrderColumnType.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports